import React from 'react';
import { Box } from '@mui/material';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import { ReactComponent as IconTeam } from '@assets/svg/team.svg';
import { ReactComponent as IconPeople } from '@assets/svg/people.svg';
import { Breakdown, CommonCard } from '@organisms';

interface CardListProps {
  loading: boolean;
  dashboardCount?: CoreDashboardNumbers;
}

const CardList: React.FC<CardListProps> = ({ dashboardCount, loading }: CardListProps) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)'
          },
          columnGap: 2,
          rowGap: 2,
          gridAutoRows: '1fr'
        }}
      >
        <CommonCard
          title="Live Accounts"
          count={dashboardCount?.total_live_locations || 0}
          icon={<IconTeam />}
          accent="success"
          loading={loading}
        />
        <CommonCard
          title="Total Contacts"
          count={dashboardCount?.total_contacts || 0}
          icon={<IconPeople />}
          accent="info"
          loading={loading}
        />
        <CommonCard
          title="Total Users"
          count={dashboardCount?.total_users || 0}
          icon={<IconPeople />}
          accent="secondary"
          loading={loading}
        />
        <CommonCard title="Twilio" icon={<SmsOutlinedIcon />} accent="warning" loading={loading}>
          <Breakdown
            items={[
              { label: 'SMS', value: dashboardCount?.total_sms_count || 0 },
              { label: 'Call', value: dashboardCount?.total_call_count || 0 }
            ]}
          />
        </CommonCard>
        <CommonCard title="Events" icon={<EventNoteOutlinedIcon />} accent="highlight" loading={loading}>
          <Breakdown
            items={[
              { label: 'Mortgage', value: dashboardCount?.total_events_mortgage || 0 },
              { label: 'Qualified', value: dashboardCount?.total_events_qualified || 0 },
              { label: 'Valuation', value: dashboardCount?.total_events_valuation || 0 }
            ]}
          />
        </CommonCard>
        <CommonCard title="WABA" icon={<WhatsAppIcon />} accent="info" loading={loading}>
          <Breakdown
            items={[
              { label: 'Template', value: dashboardCount?.total_waba_template || 0 },
              { label: 'Inbound', value: dashboardCount?.total_waba_inbound || 0 },
              { label: 'Outbound', value: dashboardCount?.total_waba_outbound || 0 }
            ]}
          />
        </CommonCard>
      </Box>
    </Box>
  );
};

export default CardList;
